import ResetForgotPassword from "./ResetForgotPassword";

export default ResetForgotPassword;
